import {
    FETCH_SCHEMES_PLAN_OPTION_REQUEST,
    FETCH_SCHEMES_PLAN_OPTION_SUCCESS,
    FETCH_SCHEMES_PLAN_OPTION_FAILURE,
  } from "./FetchMedSchemePlanOptionsTypes";
  import api from "../../utils/Api";
  
  export const fetchSchemesPlanOptionsRequest = () => {
    return {
      type: FETCH_SCHEMES_PLAN_OPTION_REQUEST,
    };
  };
  
  export const fetchSchemesPlanOptionsSuccess = (schemesPlanOptions) => {
    return {
      type: FETCH_SCHEMES_PLAN_OPTION_SUCCESS,
      payload: schemesPlanOptions,
    };
  };
  
  export const fetchSchemesPlanOptionsFailure = (error) => {
    return {
      type: FETCH_SCHEMES_PLAN_OPTION_FAILURE,
      payload: error,
    };
  };
  
  export const fetchMedSchemesPlanOptions = (plan_code) => {
    const headers = {
      Authorization:
        "Bearer " + JSON.parse(localStorage.getItem("USER_INFO")).token,
    };
    return async (dispatch) => {
      dispatch(fetchSchemesPlanOptionsRequest);
      try {
        const response = await api.get(
          "relatedparty/schemes/planoption/autocomplete?plan_code=" + plan_code,
          {
            headers: headers,
          }
        );
  
        const schemesPlanOptions = response.data.data;
        //console.log("******* patient autocomplete - ", patient);
        dispatch(fetchSchemesPlanOptionsSuccess(schemesPlanOptions));
      } catch (error) {
        console.log("Redux error - ", error.response);
        const errorMsg = error.message;
        dispatch(fetchSchemesPlanOptionsFailure(errorMsg));
      }
    };
  };
  